module.exports = __webpack_public_path__ + "img/wash-aa657c9.jpg";